import { connect, ConnectedProps } from 'react-redux';
import { RootState } from '../../../../../../store/root-reducer';
import {
  getProspectFiltersAttributeFieldValuesRequest,
  getProspectFiltersFieldValuesRequest,
  getProspectFiltersSequencesListRequest,
  getProspectFiltersClientsListRequest,
  getProspectFiltersTagsListRequest,
  getProspectFiltersOwnersListRequest,
  getProspectFiltersOutcomeListRequest,
  getProspectFiltersOwnersListForAgencyRequest,
  getProspectFiltersSubsequenceListRequest,
  getProspectLeadFinderListsRequest,
} from '../../../../extra-actions';

import ProspectFiltersValueComponent from './prospect-filters-value-component';

import {
  ProspectFiltersSequencesClientsPayload,
  ProspectFiltersValuesPayload,
  TagsGenerationType,
} from '../../../../types';
import { FilterOperation, ProspectFilterField } from '../../types';
import { resetProspectFiltersFieldsAttributesValue } from '../../../../prospect-slice';

const mapStateToProps = (state: RootState) => ({
  prospectFiltersFieldsAttributesValue:
    state.prospect.prospectFiltersFieldsAttributesValue,
  prospectFiltersFieldsAttributesLoading:
    state.prospect.prospectFiltersFieldsAttributesLoading,
  prospectFiltersFieldsAttributesFetched:
    state.prospect.prospectFiltersFieldsAttributesFetched,
});

const mapDispatchToProps = {
  sendGetProspectFiltersFieldValuesRequest: (
    payload: ProspectFiltersValuesPayload,
  ) => getProspectFiltersFieldValuesRequest(payload),

  sendGetProspectFiltersAttributeFieldValuesRequest: (
    payload: ProspectFiltersValuesPayload,
  ) => getProspectFiltersAttributeFieldValuesRequest(payload),

  sendGetProspectFiltersSequencesListRequest: (
    payload: ProspectFiltersSequencesClientsPayload,
  ) => getProspectFiltersSequencesListRequest(payload),

  sendGetProspectFiltersClientsListRequest: (
    payload: ProspectFiltersSequencesClientsPayload,
  ) => getProspectFiltersClientsListRequest(payload),

  sendGetProspectFiltersSubsequenceListRequest: (
    payload: ProspectFiltersSequencesClientsPayload,
  ) => getProspectFiltersSubsequenceListRequest(payload),

  sendGetProspectFiltersTagsListRequest: () =>
    getProspectFiltersTagsListRequest(TagsGenerationType.All),
  sendGetProspectFiltersOwnersListRequest: () =>
    getProspectFiltersOwnersListRequest(),
  sendGetProspectFiltersOwnersListForAgencyRequest: () =>
    getProspectFiltersOwnersListForAgencyRequest(),
  sendGetProspectFiltersOutcomeListRequest: () =>
    getProspectFiltersOutcomeListRequest(),
  sendGetProspectLeadFinderListsRequest: (payload: { key: string }) =>
    getProspectLeadFinderListsRequest(payload),

  resetProspectFiltersFieldsAttributesValue: (payload) =>
    resetProspectFiltersFieldsAttributesValue(payload),
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IProps = ConnectedProps<typeof connector> & {
  field: ProspectFilterField;
  operation: FilterOperation;
  value: string | number | (string | number)[];
  onUpdateFilterConditionValue: (
    value: string | number | (string | number)[],
  ) => void;
  disabled?: boolean;
  onApplyAiColEnrichmentAutoRunSettingsCondition?: any;
  fields?: any[];
};

export default connector(ProspectFiltersValueComponent);
